import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "../../styles/components/RightPanel.scss";
import Switch from "@mui/material/Switch";
import withStyles from "@mui/styles/withStyles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import { getValidInputRHS, sanitizeDecimalFieldValue } from "../../Uitls/Util";
import DownwardArrow from "../../images/DownwardArrow.svg";
import SideArrow from "../../images/SideArrow.svg";
import Outline from "../../images/Outline.svg";
import Outlinegrey from "../../images/Outlinegrey.svg";
import Tooltip from "@mui/material/Tooltip";
const textEditorToolTipNames = {
  "bold": "Bold",
  "italic": "Italic",
  "underline": "Underline",
  "strikeout": "Strikethrough",
  "uppercase": "Uppercase",
  "leftAlign": "Align Left",
  "centerAlign": "Align Center",
  "rightAlign": "Align Right",
  "bullets": "Bullets",
  "numberList": "Number List"
}

export default function TextAndButton({
  createFroalaInstance,
  froalaIndex,
  styles,
  handleFontFamily,
  fontFamilyItems,
  getFontOptionCssStack,
  fontSizeItems,
  fontWeight,
  fontWeightItems,
  AV,
  letterSpacingItems,
  handleClickSwatchFontCOlor,
  LineHeight,
  lineHeightItems,
  froalaFontAlignments,
  froalaNumberList,
  froalaFontStyles,
  handleChange,
  expanded,
  selectedComponent,
  layerCompData,
  setSelectedComponent,
  handleTextBgColor,
  localRightProps,
  setLocalRightProps,
  handleTextPropsOnchange,
  setFontSize,
  setLineHeightProp,
  setCharacterSpacing,
  setLayerCompData,
  fontAlignmentonClick,
  listOnclick,
  fontStylesonClick,
  updateSelctedFontstyle,
  isCustomScroll,
}) {
  const { t } = useTranslation();
  let locked =
    layerCompData[
      layerCompData.findIndex((selComp) => selComp.id === selectedComponent.id)
    ]?.componentStyles?.lockBoolean;

  const ScrollBar = withStyles((theme) => ({
    root: {
      width: 28,
      height: 16,
      padding: 0,
      display: "flex",
    },
    switchBase: {
      padding: 2,
      color: theme.palette.grey[500],
      "&$checked": {
        transform: "translateX(12px)",
        color: theme.palette.common.white,
        "& + $track": {
          opacity: 1,
          backgroundColor: "#203662",
          borderColor: "#203662",
        },
      },
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: "none",
      background: selectedComponent?.componentStyles?.toggleScroll
        ? "white"
        : "",
    },
    track: {
      border: `1px solid ${theme.palette.grey[500]}`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.common.white,
    },
    checked: {},
  }))(Switch);

  const ToggleScrollbar = (e) => {
    let tempSlected = { ...selectedComponent };
    tempSlected.componentStyles.toggleScroll = e.target.checked;
    setSelectedComponent(tempSlected);
  };

  const getListTypeFromHtml = (html = "") => {
    if (typeof html !== "string") return "";
    const hasListItem = /<li(\s|>)/i.test(html);
    if (!hasListItem) return "";
    if (/<ul(\s|>)/i.test(html)) return "bullets";
    if (/<ol(\s|>)/i.test(html)) return "numberList";
    return "";
  };

  useEffect(() => {
    const activeComponent =
      layerCompData?.find((comp) => comp?.id === selectedComponent?.id) ||
      selectedComponent;

    const align =
      activeComponent?.componentStyles?.textAlign === "center"
        ? "centerAlign"
        : activeComponent?.componentStyles?.textAlign === "left"
          ? "leftAlign"
          : activeComponent?.componentStyles?.textAlign === "right"
          ? "rightAlign"
            : "leftAlign";
    setAlignItem(align || "leftAlign");
    const listTypeFromSelectedId =
      activeComponent?.componentStyles?.selectedIdnumberList === 0
        ? "bullets"
        : activeComponent?.componentStyles?.selectedIdnumberList === 1
          ? "numberList"
          : "";
    const listTypeFromHtml = getListTypeFromHtml(activeComponent?.froalaText);
    setListType(
      listTypeFromSelectedId ||
        listTypeFromHtml ||
        getListTypeFromHtml(selectedComponent?.froalaText),
    );
  }, [selectedComponent, layerCompData]);

  const toggleFroalaAlignmentNumberlist = (id, type) => {
    let tempSlected = { ...selectedComponent };
    if (tempSlected?.componentStyles?.selectedIdnumberList !== id) {
      tempSlected.componentStyles.selectedIdnumberList = id;
      setSelectedComponent(tempSlected);
      setListType(type);
      let froalaText =
        createFroalaInstance.current[froalaIndex]?.editor?.html.get();
      if (
        froalaText?.includes("text-align:left") ||
        froalaText?.includes("text-align: left") ||
        froalaText?.includes("text-align : left")
      ) {
        if (id === 0 || id === 1) {
          tempSlected.componentStyles.textAlign = "left";
        }
      } else if (
        froalaText?.includes("text-align:right") ||
        froalaText?.includes("text-align: right") ||
        froalaText?.includes("text-align : right")
      ) {
        if (id === 0 || id === 1) {
          tempSlected.componentStyles.textAlign = "right";
        }
      } else if (
        froalaText?.includes("text-align:center") ||
        froalaText?.includes("text-align: center") ||
        froalaText?.includes("text-align : center")
      ) {
        if (id === 0 || id === 1) {
          tempSlected.componentStyles.textAlign = "center";
        }
      }
      const tempLayercompData = [...layerCompData];

      if (tempLayercompData[froalaIndex]?.froalaText) {
        tempLayercompData[froalaIndex].froalaText = froalaText;
      }
    } else {
      setListType("");
      tempSlected.componentStyles.selectedIdnumberList = "";
      setSelectedComponent(tempSlected);
    }
  };
  const [openfontsizeDropdown, setOpenfontsizeDropdown] = React.useState(null);
  const open = Boolean(openfontsizeDropdown);
  const [alignItem, setAlignItem] = useState("leftAlign");
  const [listType, setListType] = useState("");
  const [fontsDropDownOpen, setFontsDropDownOpen] = useState(false)
  const [fontWeightDropdownOpen, setFontWeightDropdownOpen] = useState(false)
  const fontFamilyDropdownRef = useRef(null);
  const fontWeightDropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        fontFamilyDropdownRef.current &&
        !fontFamilyDropdownRef.current.contains(event.target)
      ) {
        setFontsDropDownOpen(false);
      }

      if (
        fontWeightDropdownRef.current &&
        !fontWeightDropdownRef.current.contains(event.target)
      ) {
        setFontWeightDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleFontsizeDropdown = (event) => {
    setOpenfontsizeDropdown(event.currentTarget);
  };
  const handleClose = () => {
    setOpenfontsizeDropdown(null);
  };
  const [openletterspaceDropdown, setOpenletterspaceDropdown] =
    React.useState(null);
  const openletterSpacing = Boolean(openletterspaceDropdown);
  const handleletterSpaceDropdown = (event) => {
    setOpenletterspaceDropdown(event.currentTarget);
  };
  const handleCloseletterSpace = () => {
    setOpenletterspaceDropdown(null);
  };
  const [openlineheightDropdown, setOpenlineheightDropdown] =
    React.useState(null);
  const openlineHeight = Boolean(openlineheightDropdown);
  const handlelineHeightDropdown = (event) => {
    setOpenlineheightDropdown(event.currentTarget);
  };
  const handleCloselineHeight = () => {
    setOpenlineheightDropdown(null);
  };

  window.oncontextmenu = function () {
    handleCloselineHeight();
    handleCloseletterSpace();
    handleClose();
  };
  const handletextfield = (e, blur) => {
    let name = e.target.name;
    let value = getValidInputRHS(e, name, blur);
    if (value === -1) return;

    const decimalFields = ["fontSize", "letterSpacing", "lineHeight"];
    let sanitizedValue = sanitizeDecimalFieldValue(
      value,
      blur,
      decimalFields,
      name,
    );
    if (sanitizedValue === -1) return;

    if (name === "lineHeight") {
      const parsed = parseFloat(sanitizedValue);
      if (!isNaN(parsed) && blur === "blur" && parsed < 1) {
        sanitizedValue = 1;
      }
    }
    if (blur === "blur" && sanitizedValue === 0 && name === "fontSize") {
      sanitizedValue = 1;
    }
    let updateValue = {
      ...localRightProps,
      componentStyles: {
        ...localRightProps.componentStyles,
        [name]: sanitizedValue,
        ...(name === "fontSize" ? { datafontSize: sanitizedValue } : {}),
      },
    };

    setLocalRightProps(updateValue);
    setSelectedComponent(updateValue);

    let tempLayercompData = [...layerCompData];

    if (name === "fontSize") {
      setFontSize(sanitizedValue);
    } else if (name === "letterSpacing") {
      setCharacterSpacing(sanitizedValue);
    } else if (name === "lineHeight") {
      setLineHeightProp(sanitizedValue);
    }

    tempLayercompData.forEach((entry, index) => {
      if (entry.id === updateValue.id) {
        tempLayercompData[index].componentStyles = {
          ...tempLayercompData[index].componentStyles,
          ...updateValue.componentStyles,
        };
      }
    });

    setLayerCompData(tempLayercompData);

    if (blur === "blur") {
      layerCompData[layerCompData.length - 1].eachDrag = "no";
    } else {
      layerCompData[layerCompData.length - 1].eachDrag = "yes";
    }
  };

  const handleArrowKeyPress = (property) => (e) => {
    let values = []; // Initialize the array
    const propertyItems =
      property === "fontSize"
        ? fontSizeItems
        : property === "letterSpacing"
          ? letterSpacingItems
          : property === "lineHeight"
            ? lineHeightItems
            : null;
    for (let i = 0; i < propertyItems.length; i++) {
      let propertyItem = property + "Item";
      values.push(propertyItems[i][propertyItem]);
    }

    const currentValue = localRightProps?.componentStyles[property];
    const nextHigherValue = values.find((value) => value > currentValue);
    const nextLowerValue = values
      .slice()
      .reverse()
      .find((value) => value < currentValue);

    if (e.key === "ArrowUp") {
      e.preventDefault();
      if (nextHigherValue != undefined) {
        setLocalRightProps((prevState) => ({
          ...prevState,
          componentStyles: {
            ...prevState.componentStyles,
            [property]: nextHigherValue,
          },
        }));
      }
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      if (nextLowerValue != undefined) {
        setLocalRightProps((prevState) => ({
          ...prevState,
          componentStyles: {
            ...prevState.componentStyles,
            [property]: nextLowerValue,
          },
        }));
      }
    }
  };
  const handleInputMouseDown = (e) => {
    e.stopPropagation();
    if (document.activeElement !== e.currentTarget) {
      e.currentTarget.focus();
    }
  };

  return (
    <>
      {selectedComponent.componentType === "Text" ? (
        <hr className="hrtag" />
      ) : (
        ""
      )}
      <div className="accordion2 customAccordIcons1">
        <Accordion onChange={handleChange("panel3")}>
          <AccordionSummary
            aria-controls="panel3a-content"
            id="panel3a-header"
            expandIcon={
              expanded.panel3 === true ? (
                <img src={DownwardArrow} alt="" className="img-fluid" />
              ) : (
                <img src={SideArrow} alt="" className="img-fluid" />
              )
            }
          >
            <Typography className="accord2-summary">
              <div className="textProps">
                <div className="text">
                  {t("editorRightPanel.propertiesTabcontent.text")}
                </div>
              </div>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ pointerEvents: locked && "none" }}>
              <div>
                <div className="propertyPanelToolbar">
                  {selectedComponent.componentType === "Text" &&
                  !isCustomScroll ? (
                    <div className="enableScroll">
                      {t("editorRightPanel.propertiesTabcontent.enableScroll")}

                      <ScrollBar
                        checked={
                          selectedComponent?.componentStyles?.toggleScroll
                        }
                        onChange={(e) => {
                          ToggleScrollbar(e);
                        }}
                        className="toggleIcon "
                      />
                    </div>
                  ) : (
                    ""
                  )}

                  <div
                    className={
                      selectedComponent.componentType === "Text"
                        ? "toolbarFonts"
                        : "toolbarFontsBut"
                    }
                  >
                    <div className="fontWeightProperty">
                      <p>Font</p>
                      <div className="fontDropdown" ref={fontFamilyDropdownRef}>
                        <div
                          className="fontDropdownSelected"
                          onClick={() => setFontsDropDownOpen(prev => !prev)}
                        >
                          <span
                            style={{
                              fontFamily: getFontOptionCssStack(
                                selectedComponent?.componentStyles?.fontFamily
                              ),
                            }}
                          >
                            {selectedComponent?.componentStyles?.fontFamily}
                          </span>
                          <span className="arrow" />
                        </div>

                        {fontsDropDownOpen && (
                          <div className="fontDropdownMenu">
                            {fontFamilyItems.map((font, index) => {
                              const value = font.family || font;

                              return (
                                <div
                                  key={index}
                                  className="fontDropdownItem"
                                  style={{
                                    fontFamily: getFontOptionCssStack(value),
                                  }}
                                  onClick={() => {
                                    handleFontFamily({
                                      target: {
                                        value,
                                      },
                                    });
                                    setFontsDropDownOpen(false);
                                  }}
                                >
                                  {value}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="fontSizeProperty">
                      <div className="fontSizeItems">
                        <p className="noMargin">Size</p>
                        <div
                          className={
                            locked
                              ? "fontInputDisable  d-flex"
                              : "fontInput  d-flex"
                          }
                        >
                          <input
                            disabled={locked}
                            name="fontSize"
                            id="fontSizeIp"
                            className=" fontSizeDropdown"
                            onMouseDown={handleInputMouseDown}
                            onChange={(e) => handletextfield(e)}
                            onBlur={(e) => {
                              handletextfield(e, "blur");
                            }}
                            value={localRightProps?.componentStyles?.fontSize}
                            title=""
                            onKeyDown={handleArrowKeyPress("fontSize")}
                          />
                          <KeyboardArrowDownIcon
                            id="fontSizeIcon"
                            onClick={handleFontsizeDropdown}
                          />
                        </div>
                        <Menu
                          id="basic-menu"
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                          anchorEl={openfontsizeDropdown}
                          open={locked ? false : open}
                          onClose={handleClose}
                          class="dropdownFontinput"
                          PaperProps={{
                            style: {
                              position: "absolute",
                              width: "80px",
                              height: "150px",

                              border: "1px solid black",
                              borderRadius: "0px",
                            },
                          }}
                        >
                          {fontSizeItems.map((fontSizeItems, id) => {
                            return (
                              <MenuItem
                                key={id}
                                value={fontSizeItems.fontSizeItem}
                                onClick={(e) => {
                                  handleTextPropsOnchange(
                                    fontSizeItems.fontSizeItem,
                                    "fontSize",
                                  );
                                  handleClose();
                                }}
                              >
                                {fontSizeItems.fontSizeItem}
                              </MenuItem>
                            );
                          })}
                        </Menu>
                      </div>
                      <div className="fontWeightItems">
                        <div className="d-flex fontWeights" style={{ gap: '8px' }}>
                          <p>Weight</p>
                          <div style={{width: "60px", color: "black"}} className="fontDropdown" ref={fontWeightDropdownRef}>
                            <div
                              className={`fontDropdownSelected ${locked ? "disabled" : ""}`}
                              onClick={() => !locked && setFontWeightDropdownOpen(prev => !prev)}
                            >
                              <span style={{ fontWeight: fontWeight}}>
                                {fontWeight}
                              </span>
                              <span className="arrow" />
                            </div>

                            {fontWeightDropdownOpen && (
                              <div className="fontDropdownMenu">
                                {fontWeightItems?.map((fontWeightItem, id) => (
                                  <div
                                    key={id}
                                    className="fontDropdownItem"
                                    style={{ fontWeight: fontWeightItem }}
                                    onClick={() => {
                                      handleTextPropsOnchange(fontWeightItem, "fontWeight");
                                      setFontWeightDropdownOpen(false);
                                    }}
                                  >
                                    {fontWeightItem}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="fontDecorators justify-content-between">
                      <div className=" spacingProperty">
                        <div className=" spacingPropertyItems">
                          <img
                            src={AV}
                            alt="vertical-spacing"
                            //onClick={!locked}
                          />
                          <div
                            className={
                              locked
                                ? "fontInputDisable letterSpcing d-flex"
                                : "fontInput letterSpcing d-flex"
                            }
                          >
                            <input
                              disabled={locked}
                              name="letterSpacing"
                              className=" fontSizeDropdown lettspacing"
                              onBlur={(e) => handletextfield(e, "blur")}
                              onChange={(e) => handletextfield(e)}
                              value={
                                localRightProps?.componentStyles?.letterSpacing
                              }
                              onKeyDown={handleArrowKeyPress("letterSpacing")}
                              title=""
                            />
                            <KeyboardArrowDownIcon
                              id="fontSizeIcon"
                              onClick={handleletterSpaceDropdown}
                            />
                          </div>
                          <Menu
                            id="basic-menu"
                            MenuListProps={{
                              "aria-labelledby": "basic-button",
                            }}
                            anchorEl={openletterspaceDropdown}
                            open={locked ? false : openletterSpacing}
                            onClose={handleCloseletterSpace}
                            class="dropdownFontinput "
                            PaperProps={{
                              style: {
                                position: "absolute",
                                width: "80px",
                                height: "101px",
                                border: "1px solid black",
                                borderRadius: "0px",
                              },
                            }}
                          >
                            {letterSpacingItems.map(
                              (letterSpacingItems, id) => {
                                return (
                                  <MenuItem
                                    key={id}
                                    value={letterSpacingItems.letterSpacingItem}
                                    onClick={(e) => {
                                      handleTextPropsOnchange(
                                        letterSpacingItems.letterSpacingItem,
                                        "letterSpacing",
                                      );
                                      handleCloseletterSpace();
                                    }}
                                  >
                                    {letterSpacingItems.letterSpacingItem}
                                  </MenuItem>
                                );
                              },
                            )}
                          </Menu>
                        </div>
                        <div className=" lineHeightItems">
                          <img
                            src={LineHeight}
                            alt="lineHeight"
                            //onClick={!locked}
                          />
                          <div
                            className={
                              locked
                                ? "fontInputDisable letterSpcing d-flex"
                                : "fontInput  letterSpcing d-flex"
                            }
                          >
                            <input
                              type="number"
                              disabled={locked}
                              name="lineHeight"
                              className=" fontSizeDropdown"
                              style={{ width: "100%" }}
                              onBlur={(e) => handletextfield(e, "blur")}
                              onChange={(e) => handletextfield(e)}
                              value={
                                localRightProps?.componentStyles?.lineHeight
                              }
                              onKeyDown={handleArrowKeyPress("lineHeight")}
                              title=""
                            />
                            <KeyboardArrowDownIcon
                              id="fontSizeIcon"
                              onClick={handlelineHeightDropdown}
                            />
                          </div>

                          <Menu
                            id="basic-menu"
                            MenuListProps={{
                              "aria-labelledby": "basic-button",
                            }}
                            anchorEl={openlineheightDropdown}
                            open={locked ? false : openlineHeight}
                            onClose={handleCloselineHeight}
                            class="dropdownFontinput letterspacing"
                            PaperProps={{
                              style: {
                                position: "absolute",
                                width: "80px",
                                height: "120px",
                                border: "1px solid black",
                                borderRadius: "0px",
                              },
                            }}
                          >
                            {lineHeightItems.map((lineHeightItems, id) => {
                              return (
                                <MenuItem
                                  key={id}
                                  value={lineHeightItems.lineHeightItem}
                                  onClick={(e) => {
                                    handleTextPropsOnchange(
                                      lineHeightItems.lineHeightItem,
                                      "lineHeight",
                                    );
                                    handleCloselineHeight();
                                  }}
                                >
                                  {lineHeightItems.lineHeightItem}
                                </MenuItem>
                              );
                            })}
                          </Menu>
                        </div>
                      </div>
                    </div>
                    <div className="fontDecorators justify-content-between alignment">
                      {froalaFontAlignments.map((items, id) => {
                        return (
                          <Tooltip
                            title={textEditorToolTipNames[items.type] ? textEditorToolTipNames[items.type] : items.type}
                            key={id}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "black",
                                  color: "white",
                                },
                              }
                            }}
                          >
                            <div
                              onClick={() => {
                                !locked && fontAlignmentonClick(items.type, id);
                              }}
                              key={id}
                            >
                              {alignItem === items.type ? (
                                <img src={Outline} alt="" className="img-fluid" />
                              ) : (
                                <img
                                  src={Outlinegrey}
                                  alt=""
                                  className="img-fluid"
                                />
                              )}
                              {alignItem === items.type ? items.img2 : items.img}
                            </div>
                          </Tooltip>
                        );
                      })}
                      {froalaNumberList.map((items, id) => {
                        return (
                          <Tooltip
                            title={textEditorToolTipNames[items.type] ? textEditorToolTipNames[items.type] : items.type}
                            key={id}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "black",
                                  color: "white",
                                },
                              }
                            }}>
                            <div
                              onClick={() => {
                                !locked && listOnclick(items.type, id);
                                toggleFroalaAlignmentNumberlist(
                                  items.id,
                                  items.type,
                                );
                              }}
                              key={id}
                            >
                              {listType === items.type ? (
                                <img src={Outline} alt="" className="img-fluid" />
                              ) : (
                                <img
                                  src={Outlinegrey}
                                  alt=""
                                  className="img-fluid"
                                />
                              )}

                              {listType === items.type ? items.img2 : items.img}
                            </div>
                          </Tooltip>
                        );
                      })}
                    </div>
                    <div className="fontDecorators justify-content-between alignment">
                      {froalaFontStyles.map((items, id) => {
                        return (
                          <div
                            onClick={() => {
                              !locked && fontStylesonClick(items.type, items.id);
                              // updateSelctedFontstyle(items.id, items.type);
                            }}
                            key={id}
                          >
                            {selectedComponent?.componentStyles?.selectedFontStyle?.includes(
                              items.id,
                            ) ? (
                              <img src={Outline} alt="" className="img-fluid" />
                            ) : (
                              <img
                                src={Outlinegrey}
                                alt=""
                                className="img-fluid"
                              />
                            )}

                            {selectedComponent?.componentStyles?.selectedFontStyle?.includes(
                              items.id,
                            ) ||
                            (items.id === 1 &&
                              selectedComponent?.componentStyles?.boldClick &&
                              selectedComponent?.componentStyles?.fontWeight ===
                                "bold")
                              ? items.img2
                              : items.img}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="bg-fill"
                style={
                  selectedComponent?.componentType === "Text"
                    ? { marginTop: "4px" }
                    : { marginTop: "-23px" }
                }
              >
                <div className="swatch">
                  {
                    <img
                      alt=""
                      style={styles.textColor}
                      className="swatchBorder"
                      onClick={() => {
                        !locked && handleClickSwatchFontCOlor();
                      }}
                    ></img>
                  }
                </div>

                <div className="fill-color">
                  {t("editorRightPanel.propertiesTabcontent.fontColor")}
                </div>
              </div>
            </div>
            {selectedComponent.componentType === "Text" && (
              <div className="bg-fill" style={{ marginTop: "10px" }}>
                <div className="swatch">
                  {
                    <img
                      alt=""
                      style={styles.textBgColor}
                      className="swatchBorder"
                      onClick={() => {
                        !locked && handleTextBgColor();
                      }}
                    ></img>
                  }
                </div>

                <div className="fill-color">{t("Text Background Color")}</div>
              </div>
            )}
          </AccordionDetails>
        </Accordion>
      </div>
      <hr className="hr" />
    </>
  );
}
